module.exports = __webpack_public_path__ + "static/img/check.779b9dc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check.gif
// module id = mF/T
// module chunks = 1